import { Provider } from '../../config';
import { Action, UserFlow } from '../../config/networkConfig';
import { Routes } from '../../config/routes';
import { ValidationStep } from '../../services/validation';
import DefaultValidationEventBuilder from './result/DefaultValidationEventBuilder';
import IdentityTokenValidationEventBuilder from './result/IdentityTokenValidationEventBuilder';
import ValidationEventBuilder from './result/ValidationEventBuilder';

/** A mapping from network names to explainer routes */
const explainerMappings: Record<string, Routes> & Record<'default', Routes> = {
  [UserFlow.UNIQUENESS]: Routes.EXPLAINER_UNIQUENESS,
  [UserFlow.LIVENESS]: Routes.EXPLAINER_LIVENESS,
  [UserFlow.FACE_AGE_CHECK_13]: Routes.EXPLAINER_FACE_AGE_CHECK_13,
  default: Routes.EXPLAINER_DOCUMENT, // Covers document, documentNoPii, genesis, genesisNoPii, Yukon
};

/** A mapping from network names to providers */
const issuanceProviderMappings: Record<string, Provider> & Record<'default', Provider> = {
  [UserFlow.UNIQUENESS]: Provider.FACE_UNIQUENESS,
  [UserFlow.LIVENESS]: Provider.FACE_IDENTITY,
  [UserFlow.FACE_AGE_CHECK_13]: Provider.FACE_IDENTITY,
  default: Provider.WEB,
};

/** Override the issuance provider mappings for refresh */
const refreshProviderMappings: Record<string, Provider> & Record<'default', Provider> = {
  ...issuanceProviderMappings,
  [UserFlow.DOCUMENT]: Provider.FACE_IDENTITY,
};

/** Create an event builder  */
const createEventBuilder = (userFlowType: string, credentialReuse: boolean, action: Action): ValidationEventBuilder => {
  switch (userFlowType) {
    case UserFlow.UNIQUENESS:
      return new IdentityTokenValidationEventBuilder(ValidationStep.uniqueness);
    case UserFlow.LIVENESS:
    case UserFlow.FACE_AGE_CHECK_13:
      return new IdentityTokenValidationEventBuilder(ValidationStep.faceAuth);
    case UserFlow.DOCUMENT:
      return new IdentityTokenValidationEventBuilder(
        credentialReuse || action === Action.REFRESH ? ValidationStep.faceAuth : ValidationStep.identityToken,
      );
    case UserFlow.BLUE_NILE:
      return new IdentityTokenValidationEventBuilder(ValidationStep.identityToken);
    default:
      return new DefaultValidationEventBuilder();
  }
};

export default {
  explainerMappings,
  issuanceProviderMappings,
  refreshProviderMappings,
  createEventBuilder,
};
